import React from 'react';

import BranchesPage from '../BranchesPage';
import { useAuth0 } from '../../react-auth0-spa';
import { userRoles } from '../../constants';

const AdminBranchView = (props) => {
  const { user } = useAuth0();
  const { setLoggedInUser, userFromDb, fetchUserDetails } = props;

  React.useEffect(
    () => {
      setLoggedInUser(user);
      fetchUserDetails(user.email);
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  );

  // React.useEffect(
  //   () => {
  //     if (userFromDb.id) {
  //       checkBranchAccessForUser(userFromDb.id, Number(branchId));
  //     }
  //   },

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [userFromDb]
  // );

  if (
    (userFromDb && userFromDb.role === userRoles.ADMIN) ||
    userFromDb.role === userRoles.SUPER_ADMIN ||
    userFromDb.role === userRoles.ADMIN_COMPANY
  ) {
    return <BranchesPage viewBranchAsAdmin={true} />;
  }

  return <p>You are not allowed to view this page</p>;
};

export default AdminBranchView;
